export default __webpack_public_path__ + "static/media/h90sg.b2f607ac.jpg";